import React from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

import placeIcon from '@assets/icons/place.png';
import phoneIcon from '@assets/icons/phone.png';
import emailIcon from '@assets/icons/email.png';

import styles from './style.scss';

type Props = {
  icon: 'place' | 'phone' | 'email';
  text: string;
  onClick?: () => void;
};

export const TextWithIcon = ({ icon, text, onClick }: Props) => {
  const getIcon = () => {
    switch (icon) {
      case 'place':
        return placeIcon;
      case 'phone':
        return phoneIcon;
      case 'email':
        return emailIcon;
      default:
        return placeIcon;
    }
  };

  return (
    <ButtonBase
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'initial',
        padding: '4px 20px',
        borderRadius: '8px',
        gap: icon === 'place' ? '6px' : '10px',
        '@media (max-width:1280px)': {
          padding: '6px 12px',
        },
        cursor: 'pointer',
        userSelect: 'text',
      }}
      onClick={onClick}
      component={icon === 'phone' || icon === 'email' ? 'a' : 'button'}
      href={icon === 'phone' || icon === 'email' ? (icon === 'phone' ? `tel:${text}` : `mailto:${text}`) : undefined}
      target={icon === 'phone' || icon === 'email' ? '_blank' : undefined}
    >
      <img src={getIcon()} alt={icon} height={12} className={styles.icon} />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Typography variant="body1" className={styles.text}>
          {text}
        </Typography>
      </Box>
    </ButtonBase>
  );
};
